import RankList from './src/main';

/* istanbul ignore next */
RankList.install = function(Vue) {
  Vue.component(RankList.name, RankList);
};

export default RankList;
